 (function($) {

  $( '.js-galeria-carta' ).swipebox({
    hideBarsDelay : 0
  });

  $('.js-slider-galeria').slick({
    infinite: false,
    slide: 'a',
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false
  });

  $.each( $( 'img' ), function(){
    if ( !$(this).attr( 'title' ) && $(this).attr( 'alt' ) ) {
      $(this).attr( 'title', $(this).attr( 'alt' ) );
    }
  }); 

  // https://css-tricks.com/snippets/jquery/smooth-scrolling/
  $(function() {
    $('a[href*=#]:not([href=#])').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });

  // Filtro de Perfis

  Array.prototype.getUnique = function() {
    var u = {}, a = [];
    for(var i = 0, l = this.length; i < l; ++i){
      if(u.hasOwnProperty(this[i])) {
        continue;
      }
      a.push(this[i]);
      u[this[i]] = 1;
    }
    return a;
  };

  var titulos = $('.card--perfil__title');
  var iniciais = [];

  $.each( titulos, function(){
    iniciais.push( $(this).text().charAt(1) );
  });

  iniciais = iniciais.getUnique();

  $.each( iniciais, function(){
    $('.js-filtro-perfis .filtro__select').append( '<option val="' + $(this)[0] + '">' + $(this)[0] + '</option>' );
  });

  $( '.js-filtro-perfis button' ).on( 'click', function(){

    var targetChar = $('.js-filtro-perfis select').val();

    if( targetChar.length < 1 ) {
      return;
    }

    $( '.perfilWrapper' ).each(function() {
      var letra = $(this).find('.card--perfil__title').text().charAt(1);

      if( letra !== targetChar && targetChar !== '-1' ) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });

  });

  // JS Responsivo
  enquire.register("screen and (max-width: 991px)", {
    setup : function() {
    },
    match : function() { 
      $('.js-menu-toggle').on( 'click', function(){
        $('.header__menuContainer').toggle();
      });

      if ( $('body').hasClass( 'single-carta' ) ) {

        $('.js-detalhes-da-carta').on( 'click', function() {
          $('.sidebar--mobile').show();
        });

        $('.js-sidebar-mobile-hide').on( 'click', function(e) {
          e.stopPropagation();
          $('.sidebar--mobile').hide();
        });

        $('.js-sidebar-mobile')
        .append($('.brick--rd'))
        .append($('.separator')[0])
        .append($('.brick--details'))
        .append($('.separator')[1]) 
        .append($('.brick--related'));         
      }
    },
    unmatch : function() {
    }
  });

})(jQuery); // Fully reference jQuery after this point.
